import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import vendorCategoryService from "../../Services/vendorCategoryService";
import getCategoryService from "../../Services/getCategoryService";
// Fetch fitness categories
export const fetchCommunityCategories = createAsyncThunk(
  "getCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCategoryService.getAll();
      console.log("✅ Fetch Success:  Categories Data", response);

      return response?.categories || []; // Ensure correct structure
    } catch (error) {
      console.error("❌ Fetch Failed:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

const fitnessCategorySlice = createSlice({
  name: "getCategory",
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunityCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload || []; // Ensure payload is correctly assigned
      })
      .addCase(fetchCommunityCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default fitnessCategorySlice.reducer;
